import { useMutation, useQueryClient } from '@tanstack/vue-query'
import { supportKeys } from '../supportQueryKeys'
import { createSupportTicket } from '../supportEndpoints'
import { parseCreatedTicketReference } from '../parsers/supportTicketParser'

// Files a ticket as the signed-in seller and refreshes Previous Requests.
export function useCreateSupportTicketMutation() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (request: Parameters<typeof createSupportTicket>[0]) =>
      createSupportTicket(request).then(parseCreatedTicketReference),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: supportKeys.ticketLists() })
    },
  })
}
